import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { startOfMonth, endOfMonth } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

export default function RangePicker({ onRangeChange, className }) {

    // Default range = current month
    const [range, setRange] = useState([
        startOfMonth(new Date()),
        endOfMonth(new Date())
    ]);

    const [startDate, endDate] = range;

    const handleChange = (dates) => {
        const [start, end] = dates;
        setRange(dates);

        // Only fire API when user completes range selection
        if (start && end) {
            onRangeChange(start, end);
        }
    };

    return (
        <DatePicker
            selectsRange
            startDate={startDate}
            endDate={endDate}
            onChange={handleChange}
            isClearable={false}
            className={`form-control ${className} bg-transparent`}
        />
    );
}
